import { render, staticRenderFns } from "./header.vue?vue&type=template&id=687d47c4&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "./header.vue?vue&type=style&index=0&id=687d47c4&prod&scoped=true&lang=css"
import style1 from "./header.vue?vue&type=style&index=1&id=687d47c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687d47c4",
  null
  
)

export default component.exports